module.exports = __webpack_public_path__ + "static/category-underwear-a942f7fcf38d20b5a7934df57fbdb0fd.jpg";